import React from 'react'
import ApplicationStore from '../../GeneralApplication/Application/ApplicationStore'
import { PlanSelection } from '../../../ui/organisms/PaymentPlanSelectBottomModal'
import { useInvoiceDetailsContext } from '../TabInvoice/InvoiceDetailsContext'
import Application from '../../GeneralApplication/Application'
import { observer } from 'mobx-react-lite'
import { ScreenWithCobrandingHeader } from '../../../ui/white-label-components/ScreenWithCobrandingHeader'
import { PayInvoice } from '../InvoicesTab/PayInvoice/PayInvoiceModal'

export const CreditRequest = observer(() => {
  const { setPayAndSubmitApplication } = ApplicationStore
  const { paymentPlanModalVisibility, payInvoiceModal } =
    useInvoiceDetailsContext()
  setPayAndSubmitApplication(true)

  let Component: React.FC
  if (paymentPlanModalVisibility) {
    Component = PlanSelection
  } else if (payInvoiceModal) {
    Component = PayInvoice
  } else {
    Component = Application
  }
  return (
    <ScreenWithCobrandingHeader>
      <Component />
    </ScreenWithCobrandingHeader>
  )
})
